// removed by extract-text-webpack-plugin
module.exports = {"header":"pre-acceptance-header__header___2wzCC","logo":"pre-acceptance-header__logo___1pVJo","lang":"pre-acceptance-header__lang___22tZ9"};


//////////////////
// WEBPACK FOOTER
// ./src/components/new-header/pre-acceptance-header.scss
// module id = 674
// module chunks = 0